import { paramsToQueryString, queryStringToParams } from 'Helpers/url';

const excludedParams = ['lang', 'cursor'];
const sortObject = params => Object.keys(params).sort().reduce((r, k) => Object.assign(r, { [k]: params[k] }), {});

const getHashValue = (name, urlWithoutParams, params) => {
    params = Object.assign({}, params);
    params = sortObject(params);
    const queryParams = paramsToQueryString(params);

    return queryParams ? `${name}#${urlWithoutParams}#${queryParams}` : `${name}#${urlWithoutParams}`;
};

export const getType = (type, url) => {
    const arr = url ? url.split('?') : [];
    const urlParams = arr[1] ? arr[1] : null;
    const urlWithoutParams = arr[0] ? arr[0] : null;

    type = type.toLowerCase();
    if (urlParams) {
        const params = queryStringToParams(urlParams);

        excludedParams.forEach(val => {
            if (Object.prototype.hasOwnProperty.call(params, val)) {
                delete params[val];
            }
        });
        return getHashValue(type, urlWithoutParams, params).toLowerCase();
    }
    const hashVal = urlWithoutParams ? `${type}#${urlWithoutParams}` : type;

    return hashVal.toLowerCase();
};
